import ActTeamManagement from './ActTeamManagement';

export default ActTeamManagement;
